import { hasLocalStorage } from "common/components/utils/hasLocalStorage";

import {
    NotSupportedBrowser
} from "common/helpers/errors";

import { emitter } from "common/emitter";

const testCases = [
    {
        name: "cors",
        test: "XMLHttpRequest" in window && "withCredentials" in new XMLHttpRequest(),
        description: "Check if browser supports CORS requests necessary for interaction with Pazien API"
    },
    {
        name: "RequestAnimationFrame",
        test: "requestAnimationFrame" in window,
        description: "Check if browser supports requestAnimationFrame necessary for async processing"
    },
    {
        name: "Local storage",
        get test() {
            return hasLocalStorage();
        },
        description: "Check if browser supports Local storage necessary to store credentials, persisted reducers, and other session data"
    }
];

export async function checkBrowser() {
    const failedTests = testCases.filter((testCase) => !testCase.test);
    if (failedTests.length) {
        // Track failed tests in tracking tool
        emitter.emit("tracking.track", {
            type: "outdated_browser",
            data: failedTests
        });
        
        throw new NotSupportedBrowser({
            custom: true,
            actions: false,
            header: "Unsupported browser",
            message: "Pazien does not run on your current browser.",
            extra: {
                failedTests
            }
        });
    }
    
    return true;
}
